/**
 * Phase 38 — what happens when a drop hits, as one settings grid (user,
 * 20/10/2026: "please improve UI/UX because the buttons, everything, labels
 * is so horrible"): Amount (one select, its number only when needed) ·
 * Limit (No limit | Set a limit) · SMS cap (No cap | Set a cap) · Sends (the chain in
 * number chips) · Texts (the drop that hit's, or new texts — the Config tab's
 * setting, 21/10/2026) — then "Goes out", passed in as children, so every
 * row shares one label column and one control height (action/HitGrid).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, ReactNode } from 'react';
import type { DropGenTextMix, DropGenTextMixInput } from '@trafficpulse/shared';

import type { DraftHitAgain } from '../../../../drop-generator.types';
import { HitAmount } from './action/HitAmount';
import { HitGrid } from './action/HitGrid';
import { HitCapRow, HitLimitRow } from './action/HitLimitRows';
import { HitSendsRow } from './action/HitSendsRow';
import { HitTextsRow } from './action/HitTextsRow';

interface Props {
  hitAgain: DraftHitAgain;
  defaultAmount: number;
  onPatch: (patch: Partial<DraftHitAgain>) => void;
  /** The draft's text mix input — the Texts row reads the hit-again kind's policy from it. */
  cfg: DropGenTextMixInput;
  /** Writes Hit again's texts (undefined = the texts of the drop that hit). */
  onPolicy: (mix: DropGenTextMix | undefined) => void;
  /** More rows of the same grid (Goes out). */
  children?: ReactNode;
}

export const HitAgainAction: FC<Props> = ({ hitAgain, defaultAmount, onPatch, cfg, onPolicy, children }) => {
  const row = { hitAgain, defaultAmount, onPatch };
  return (
    <HitGrid>
      <HitAmount {...row} />
      <HitLimitRow {...row} />
      <HitCapRow {...row} />
      <HitSendsRow hitAgain={hitAgain} defaultAmount={defaultAmount} />
      <HitTextsRow cfg={cfg} onPolicy={onPolicy} />
      {children}
    </HitGrid>
  );
};
